export default from './user-badge';



// WEBPACK FOOTER //
// ./app/components/user-badge/index.js